import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { Chip, Stack, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import ModalBoxes from 'common/feedback/ModalBoxes/ModalBoxes';
import moment from 'moment';

import { NSPP_ENABLEMENT } from '../../../../../../../../services/i18n/namespaces';
import { PatientInfoContext } from '../../../PatientInfoContext';

import PatientPortalInvitationModal from './PatientPortalInvitationModal/PatientPortalInvitationModal';

const PPS_ENABLED = 'enabled';
const PPS_NOT_ENABLED = 'notEnabled';
export default function PatientPortalTab() {
  const { t } = useTranslation();
  const { patientInfo, setPatientInfo } = useContext(PatientInfoContext);
  return (
    <Stack direction="column" spacing={2}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: 'center',
          py: patientInfo?.portalLastInvitedAt ? 0 : 2
        }}
      >
        <Typography variant="subtitle2">Portal</Typography>
        <Chip label={t(`${patientInfo?.portalLastInvitedAt ? PPS_ENABLED : PPS_NOT_ENABLED}`)} />
        <Button
          disabled={patientInfo?.portalLoginHappened || !patientInfo?.email}
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={function() {
            ModalBoxes.open({
              component: <PatientPortalInvitationModal patientInfo={patientInfo} />,
              onClose(r) {
                if (!r?.id) {
                  return;
                }
                setPatientInfo(state => {
                  return { ...state, portalLastInvitedAt: r.lastInvitedAt, portalLoginHappened: r.loginHappened };
                });
              }
            });
          }}
        >
          {t(`${NSPP_ENABLEMENT}:portal.invite`)}
        </Button>
        {!patientInfo?.email && (
          <Typography variant="caption" color="error">
            {t(`${NSPP_ENABLEMENT}:portal.emailCantBeEmpty`)}
          </Typography>
        )}
      </Stack>
      {patientInfo?.portalLastInvitedAt && (
        <Typography variant="body2" color="text.secondary">
          {t(`${NSPP_ENABLEMENT}:portal.lastInvited`)}:{' '}
          {moment(patientInfo.portalLastInvitedAt).format('MMM DD, YYYY [at] h:mm A')}
        </Typography>
      )}
    </Stack>
  );
}
